import { Infractions } from '@/interfaces/my-profile/my-profile';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-infringement-card',
  templateUrl: './infringement-card.component.html',
  styleUrls: ['./infringement-card.component.css']
})
export class InfringementCardComponent implements OnInit {

  @Input() infraction : Partial<Infractions>  = {}; 
  @Input() infractionIndex : number = 0;
  @Input() cardType : 'search' | '' = '';

  constructor() { }

  ngOnInit(): void {

  }

}
